import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import TweenMax, {Expo, Power1, Sine, TweenLite} from "gsap";
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import * as PIXI from "pixi.js";
import Config from "@/config/Config";
import PlaneConfig from "@/config/PlaneConfig";
import GameStatesEnum from "@/states/GameStatesEnum";
import BulletContainer from "@/containers/BulletContainer";
import PlaneAnimationContainer from "@/containers/PlaneAnimationContainer";

export default class PlaneContainer extends BaseContainer {

  static DEBUG = false
  static StateInit = 'Init'
  static StateLand = 'StateLand'
  static StateFlight = 'StateFlight'
  static StateBattle = 'StateBattle'

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {

    this.arr = PlaneContainer.DEBUG ? [] : PlaneConfig.plane
    this.isPilotOff1 = false
    this.isPilotOff2 = false
    this.planeX = -450
    this.planeY = -195
    this.parachutistsOnScreen = 0
    this.parachutists = []
    this.parachutistPool = []
    this.activeBullets = []
    this.itemsPool = []
    this.state = PlaneContainer.StateInit

    Signals.startFeature.add(this.onStartFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.multiplier.add(this.updateMultiplier, this)
    Signals.forceRoundStart.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.playerTakeWin.add(this.onPlayerParachute, this)
    Signals.stateChanged.add(this.onGameStateChanged, this)
    //Signals.playersStateChanged.add(this.onPilotsStateChanged, this)


    this.bulletsContainer = new PIXI.Container()
    this.addChild(this.bulletsContainer)

    this.parachutesContainer = new PIXI.Container()
    this.addChild(this.parachutesContainer)

    this.pilot1 = new SpineAnimation('PilotCatapult')
    this.pilot1.start(['PilotSits'], [true])
    this.pilot1.x = 56
    this.pilot1.y = 22
    this.pilot1.visible = false
    this.pilot1.scale.set(0.8)

    this.pilot2 = new SpineAnimation('PilotCatapult')
    this.pilot2.start(['PilotSits'], [true])
    this.pilot2.x = 25
    this.pilot2.y = 16
    this.pilot2.visible = false
    this.pilot2.scale.set(0.9)

    this.container = new PIXI.Container()
    this.addChild(this.container)

    this.planeContainer = new PIXI.Container()
    this.container.addChild(this.planeContainer)

    this.chassis = new SpineAnimation('JetChassis')
    this.chassis.scale.set(1.1)
    this.chassis.position.set(-5, -2)
    this.chassis.start(['ChassisOpen'], [true])
    this.planeContainer.addChild(this.chassis)

    this.planeContainer.addChild(this.pilot1)
    this.planeContainer.addChild(this.pilot2)

    this.plane = new PlaneAnimationContainer()
    this.planeContainer.addChild(this.plane)
    this.plane.scale.set(1.2)
    this.plane.setState(PlaneAnimationContainer.StateJetEngineOff)
    //  this.plane.start (['JetEngineOff'], [false])

    this.explosion = new SpineAnimation('ExplosionAnim')
    this.container.addChild(this.explosion)
    this.explosion.visible = false

    this.container.position.set(this.planeX, this.planeY)
    this.planeContainer.angle = 2.3
    this.parachutesContainer.position.set(this.container.x, this.container.y)
    this.container.visible = false

    this.onOrientationChanged(Facade.orientation)
  }

  updateMultiplier(multiplier) {
    this.currentDeep = multiplier
    if (this.currentDeep > PlaneConfig.deepChangeAnimation && this.state === PlaneContainer.StateLand) {
      // this.plane.start(['JetEngineOn','JetLandIdle'], [false, true])
      this.changeState(PlaneContainer.StateFlight)
    }

  }

  onMakeBets() {
    console.log(`%c onMakeBets`, 'color:white;background: red')
    this.x = Config.currentPattern.planeContainer.x
    this.planeMask.visible = true
    this.container.mask = this.planeMask
    this.container.position.set(this.planeX, this.planeY)
    this.container.visible = false
    this.plane.visible = true
    // this.plane.start(['JetEngineOn'], [true])
    this.plane.setState(PlaneAnimationContainer.StateJetEngineOn)
    this.container.rotation = 0
    this.state = PlaneContainer.StateInit
    this.isPilotOff1 = false
    this.isPilotOff2 = false
  }

  reset() {
    console.log(`%c reset`, 'color:white;background: red')        // setTimeout(() => {
    //     this.container.position.set(this.planeX, this.planeY + 200)
    // }, 50)

    this.stop()
    this.isPlaneStopped = false
    this.isPilotOff1 = false
    this.isPilotOff2 = false
    this.changeState(PlaneContainer.StateInit)
    //  this.pilot1.start ([ 'PilotSits'], [true])
    //   this.pilot2.start ([ 'PilotSits'], [true])

    this.explosion.visible = false
    this.explosion.stop()
    //   this.plane.start (['JetEngineOff'], [false])
    this.plane.setState(PlaneAnimationContainer.StateJetEngineOff)
    this.plane.reset()
    this.plane.visible = true
    this.chassis.visible = true
    this.chassis.start(['ChassisOpen'], [true])
    this.chassis.position.set(-5, 0)

    this.parachutistsOnScreen = 0
    this.container.rotation = 0
    this.state = PlaneContainer.StateInit

    this.onPilotsStateChanged()

    console.log('Facade.state  ', Facade.state)
    if (Facade.state === 'lift' || Facade.state === 'progress') {
      this.container.position.set(this.planeX, this.planeY + 100)
      TweenMax.to(this.container, 2, {y: this.planeY, onComplete: this.onStartPlane.bind(this)})
    } else {
      this.container.position.set(this.planeX, this.planeY)
    }
    this.planeContainer.angle = 2.3
    this.container.visible = true
    this.parachutesContainer.position.set(this.container.x, this.container.y)

    while (this.parachutists.length > 0) {
      this.poolIn(this.parachutists.pop())
    }

    while (this.activeBullets.length > 0) {
      const b = this.activeBullets.pop()
      b.stop()
      this.poolBulletIn(b)
    }
    this.activeBullets.length = 0
  }

  onStartPlane() {
    Facade.soundManager.play('jet2_VO_TakeOff', 0.4)
    this.plane.setState(PlaneAnimationContainer.StateJetStart)
    //  this.plane.start (['JetEngineOff', 'JetEngineOn', 'JetLandIdle'], [false, false, true])
  }

  onGameStateChanged(state) {
    console.log('state', state)
    switch (state) {
      case GameStatesEnum.ROUND_START:
        break
    }
  }

  onStartFeature() {
    console.log(`%c onStartFeature`, 'color:white;background: green')
    TweenMax.to(this, 1, {x: Config.currentPattern.planeContainer.x - 300})
    this.delayedCallShooting = TweenLite.delayedCall(1.7, () => {
      this.shooting()
    })
    this.isShooting = true
  }

  onStopFeature() {
    console.log(`%c onStopFeature`, 'color:white;background: green')
    this.changeState(PlaneContainer.StateFlight)
    this.delayedCallShooting.kill();
    TweenLite.killTweensOf(this)
    this.dcShoot ? this.dcShoot.kill() : 0
    this.isShooting = false
    while (this.activeBullets.length > 0) {
      const b = this.activeBullets.pop()
      b.stop()
      this.poolBulletIn(b)
    }
    this.activeBullets.length = 0
    if (!this.isStoppped) {
      TweenMax.to(this, 1, {x: Config.currentPattern.planeContainer.x})
    }
  }

  onPilotsStateChanged() {
    const pilot1 = Facade.model.playerState1
    const pilot2 = Facade.model.playerState2
    this.pilot1.x = 56
    this.pilot1.y = 22

    this.pilot2.x = 25
    this.pilot2.y = 16

    this.pilot1.visible = (pilot1.b > 0) && !this.isPilotOff1
    this.pilot2.visible = (pilot2.b > 0) && !this.isPilotOff2

    console.log(`%c ppp - ${pilot1.b}  ${this.isPilotOff1}   ${pilot2.b}  ${this.isPilotOff2}`, 'color:white;background: blue')
    console.log(`%c pilot - ${this.pilot1.visible}  ${this.pilot2.visible}`, 'color:white;background: blue')
  }

  start() {
    console.log(`%c start`, 'color:white;background: red')
    this.isStoppped = false
    this.container.mask = null
    this.planeMask.visible = false
    this.container.visible = true
    this.onPilotsStateChanged()

    if (PlaneContainer.DEBUG) {
      this.arr.length = 0
      // TweenMax.to(this.container, 2, {x: '+=300', onComplete: () => {
      //         TweenMax.to(this.container, 1, {y: '-=150', onComplete: () => {
      //                 TweenMax.to(this.container, 1.5, {angle: '-= 25', delay: 3, onComplete: () => {
      //                         TweenMax.to(this.container, 2, {angle: 0})
      //                 }})
      //         }})
      // }})
      TweenMax.to(this.container, 2, {x: '+=420', delay: 0.5})
      TweenMax.to(this.container, 3, {y: '-=65', delay: 1.5})
      TweenMax.to(this.planeContainer, 1.5, {
        angle: '-=10', delay: 1, onComplete: () => {
          TweenMax.to(this.planeContainer, 1.5, {angle: 0})
        }
      })

      // this.plane.start([ 'JetFlightIdle', 'JetFlightIdle'], [false, true])
      this.plane.setState(PlaneAnimationContainer.StateJetFlight)
      Signals.tick.add(this.update, this)
      return
    }
    this.a = Math.round(Facade.model.deltaTime * 60)
    if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
      const o = this.arr[this.arr.length - 1]
      this.planeContainer.angle = o.a
      this.container.x = o.x
      this.container.y = o.y
      this.changeState(PlaneContainer.StateFlight)
      this.container.visible = true
      return
    }

    this.changeState(PlaneContainer.StateLand)
    Signals.tick.add(this.update, this)
    //Signals.tickerStart.dispatch()
  }

  stop() {
    console.log(`%c stop`, 'color:white;background: yellow')
    this.isStoppped = true
    this.isShooting = false
    //   this.shield.visible = false
    TweenLite.killTweensOf(this)
    this.delayedCallShooting ? this.delayedCallShooting.kill() : 0
    this.dcShoot ? this.dcShoot.kill() : 0
    // if(PlaneContainer.DEBUG) {
    //     TweenMax.killTweensOf(this.container)
    //     console.log(this.arr)
    // }
    // Signals.tick.remove(this.update, this)

    this.isPlaneStopped = true
    this.changeState(this.state)
// PilotSits  PilotCatapultAnimation  PilotSitsFlight
    Signals.tick.remove(this.update, this)
    Signals.stopFly.dispatch()
  }

  changeState(state) {
    let listPlane = []
    let listLoopsPlane = [true]
    let namePilot = ''
    console.log(`%c state${this.state} ${state}`, 'color:white;background: blue')
    switch (state) {
      case PlaneContainer.StateInit:
        listPlane = ['JetEngineOff']
        namePilot = 'PilotSits'
        this.chassis.start(['ChassisOpen'], [true])
        this.plane.setState(PlaneAnimationContainer.StateJetEngineOff)
        break
      case PlaneContainer.StateLand:
        listPlane = !this.isPilotOff1 && !this.isPilotOff2 ? ['JetLandIdle'] : ['JetLandIdlePilotOff']
        namePilot = 'PilotSits'
        this.plane.setState(PlaneAnimationContainer.StateJetLand)
        this.chassis.start(['ChassisOpen'], [false])
        break;
      case PlaneContainer.StateFlight:
        listPlane = !this.isPilotOff1 && !this.isPilotOff2 ? ['JetFlightIdle'] : ['JetFlightIdlePilotOff']
        namePilot = 'PilotSitsFlight'
        if (this.state === PlaneContainer.StateLand) {
          this.chassis.start(['ChassisHide'], [false])
          TweenLite.delayedCall(0.5, () => {
            this.chassis.visible = false
          })
        } else {
          this.chassis.visible = false
        }
        this.plane.setState(PlaneAnimationContainer.StateJetFlight)
        break;
      case PlaneContainer.StateBattle:
        listPlane = !this.isPilotOff1 && !this.isPilotOff2 ? ['hitRegular'] : ['hitPilotOff']
        listLoopsPlane = [true]
        namePilot = 'PilotSitsFlight'
        this.plane.setState(PlaneAnimationContainer.StateJetBattle)
        break;
    }
    this.state = state
    //this.plane.start(listPlane, listLoopsPlane)

    console.log('changeState namePlane', listPlane, 'namePilot', namePilot)
    if (!this.isPilotOff1) {
      this.pilot1.start([namePilot], [true])
    }
    if (!this.isPilotOff2) {
      this.pilot2.start([namePilot], [true])
    }
  }


  update() {

    if (PlaneContainer.DEBUG) {
      const a = {
        x: Number(this.container.x.toFixed(2)),
        y: Number(this.container.y.toFixed(2)),
        a: Number(this.planeContainer.angle.toFixed(2)),
      }
      this.arr.push(a)
      return
    }
    const o = this.arr[this.a]
    this.container.y = o.y
    this.container.x = o.x
    this.planeContainer.angle = o.a
    this.a++
    if (this.a === this.arr.length) {
      this.a = this.arr.length - 1
      // this.stop()
    }
  }

  onRoundEnd() {
    console.log(`%c onRoundEnd`, 'color:white;background: red')
    this.parachutists.length = 0
    // this.plane.visible = false
    this.chassis.visible = false
    this.explosion.visible = true
    TweenMax.killTweensOf(this.pilot1)
    TweenMax.killTweensOf(this.pilot2)
    if (!this.isPilotOff1) {
      this.pilot1.visible = false
    }
    if (!this.isPilotOff2) {
      this.pilot2.visible = false
    }

    TweenLite.delayedCall(0.8, () => {
      this.container.mask = this.planeMask
      this.planeMask.visible = true

      this.container.visible = false
    })

    //    this.explosion.position.set(this.container.position.x, this.container.position.y)
    if (this.state === PlaneContainer.StateBattle) {
      this.explosion.start(['ExplosionBattleJet'], [false])
    } else {
      this.explosion.start(['ExplosionAnim'], [false])
    }
    this.stop()

    if (PlaneContainer.DEBUG) {
      console.log('::: arr plane', this.arr)
      this.arr = []
    }
  }

  onPlayerParachute(data) {

    const catapult = (pilot, pilot2, isPilotOff) => {
      pilot.start(['PilotCatapultAnimation'], [false])
      if (!isPilotOff) {
        if (this.state === PlaneContainer.StateFlight) {
          this.plane.setState(PlaneAnimationContainer.StateJetFlight, false)
          pilot2.start(['PilotSitsFlight'], [true])
        }
        if (this.state === PlaneContainer.StateBattle) {
          this.plane.setState(PlaneAnimationContainer.StateJetBattle, false)
          pilot2.start(['PilotSitsFlight'], [true])
        }
        if (this.state === PlaneContainer.StateLand) {
          this.plane.setState(PlaneAnimationContainer.StateJetLand, false)
        }
        TweenMax.to(pilot, 0.5, {
          x: '-=100', ease: Power2.easeIn, delay: 0.2, onComplete: () => {
            TweenMax.to(pilot, 2, {
              x: '-=300', onComplete: () => {
                pilot.visible = false
              }
            })
          }
        })
      }
    }

    if (data.i === Facade.model.betId1) {
      catapult(this.pilot1, this.pilot2, this.isPilotOff1)
      this.isPilotOff1 = true
      return
    }
    if (data.i === Facade.model.betId2) {
      catapult(this.pilot2, this.pilot1, this.isPilotOff2)
      this.isPilotOff2 = true
      return
    }
    const p = this.poolOut()
    p.start(['PilotCatapultAnimation'], [false])
    this.parachutesContainer.position.set(this.container.x, this.container.y - 30)
    TweenMax.to(p, 0.5, {
      x: '-=100', ease: Power2.easeIn, delay: 0.2, onComplete: () => {
        TweenMax.to(p, 2, {
          x: '-=300', onComplete: () => {
            p.visible = false
          }
        })
      }
    })
  }

  poolIn(parachutist) {
    parachutist.position.set(0, 0)
    parachutist.stop()
    parachutist.visible = false
    this.parachutistPool.push(parachutist)
    parachutist.stop()
  }

  poolOut() {
    if (this.parachutistPool.length === 0) {
      const p = new SpineAnimation('ParachutistAnim')
      this.parachutesContainer.addChild(p)
      this.parachutistPool.push(p)
    }
    return this.parachutistPool.pop()
  }

  shooting() {
    this.shoot()

    this.shootingInterval = window.setInterval(() => {
      if (this.isShooting) {
        Facade.soundManager.play('jet2_game_jet_attack', 0.4)
      } else {
        clearInterval(this.shootingInterval)
      }
    }, 700)

    this.changeState(PlaneContainer.StateBattle)
  }

  shoot() {
    const b = this.poolBulletOut()
    this.activeBullets.push(b)
    b.position(50, -170)
    b.start()
    if (this.isShooting) {
      this.dcShoot = TweenLite.delayedCall(2.92, () => {
        this.shoot()
      })
    }
  }

  poolBulletIn(item) {
    this.itemsPool.push(item)
    item.visible = false
  }

  poolBulletOut() {
    if (this.itemsPool.length === 0) {
      const p = new BulletContainer('missile', 480)
      this.bulletsContainer.addChild(p)
      this.itemsPool.push(p)
    }
    const p = this.itemsPool.pop()
    p.visible = true
    return p
  }

  hideMask() {
    this.planeMask && (this.planeMask.visible = false)
  }

  showMask() {
    this.planeMask && (this.planeMask.visible = true)
  }

  createMask() {
    if (this.planeMask) {
      this.removeChild(this.planeMask)
      this.planeMask = null
    }

    this.planeMask = new PIXI.Graphics()
    this.planeMask.beginFill(0xffffff)

    this.planeMask.drawRect(-630, -630, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height - 603)
    /*
            switch (orientationSymbol) {
                case 'Hd':
                    this.planeMask.drawRect(-430, -430, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height - 70)
                    break

                case 'Vm':
                    this.planeMask.drawRect(-430, -440, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height - 70)
                    break
            }
      */
    this.planeMask.endFill()
    this.container.mask = this.planeMask
    this.addChild(this.planeMask)
  }

  onOrientationChanged(orientationSymbol) {
    this.createMask()
  }

}
